<template>
  <section class="service">
    <HeaderBar :my-title="myHeader" :is-prev="true"></HeaderBar>
    <ul class="problem-list">
      <li v-for="(item,index) in problemList" @click="getProblem(index)" :class='{active:index===number}'>{{item}}</li>
      
    </ul>
    <div class="main" v-bind:is="currentView">
        
    </div>
   
    <FooterBar :num="3"></FooterBar>
  </section>
  
  

</template>

<script>
import FooterBar from './base/footer'
import HeaderBar from './base/header'
import phone from './base/phone'
import scene from './base/scene'
export default {
  components: {
    HeaderBar,
    FooterBar,
    phone,
    scene
  },
  name: 'service',
  created: function () {
    
  },
  data () {
    return {
      problemList:["电话","现场"],
      problemCon: {},
      number:0,
      myHeader:"彩虹客服",
      isPrevShow:false,
      currentView:phone,
      myWidth:0
        
     
    }
  },
  methods:{
    getProblem(num){
      this.number= num;
      if(num==0){
        this.currentView =phone
      }
      if(num==1){
        this.currentView =scene
      }

      this.countNumber(4,num+1)
    }
  },
  computed: {
    /*
     countHeight() {

        this.myWidth = document.documentElement.clientHeight+'px'
        return this.myWidth
     
     }
*/
  },
   mounted () {
   
  }
}
</script>


<style scoped>
.service{background: #fafafa;height: 100%}
.problem-list{font-size: 0.3rem;color: #999999;margin-top: 0.35rem;height: 1rem;overflow:hidden;border-bottom: 0.1rem solid #e6e6e6;margin-bottom: 0.5rem}
.problem-list li{float: left;margin-right: 0.93rem;height: 100%;}
.problem-list li:nth-of-type(1){margin-left:2rem}
.problem-list .active{color: #000;background: url(../assets/problem-list.png) no-repeat center 0.58rem;background-size: 0.5rem 0.08rem;}
.main h6{font-size:0.32rem;margin: 0rem 0 0.5rem 0rem;font-weight: normal;border-top: 0.14rem solid #e6e6e6;padding-left: 0.66rem;padding-top: 0.42rem}
.main div{font-size: 0.3rem;width: 4.65rem;padding: 0 1rem;height: 1rem;line-height: 1rem;text-align: center;color: #fff;background: #e5004f;margin-left: 0.45rem;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
.main div:nth-of-type(2){background: #fafafa;border: 1px solid #d7d7d7;color: #999;margin-top: 0.24rem}

</style>



// WEBPACK FOOTER //
// src/components/service.vue